import React from "react";
import "./CoralRecStats.scss";
import utils from "../../../../helpers/utils";
import { CRT } from "../CoralRecTourismConfig";
import SmallStat from "../../../Stats/SmallStat";
import LargeStat from "../../../Stats/LargeStat";
import { Grid } from "@material-ui/core";

function CoralRecStats(props) {
  const { stats, handleStatClick, selectedStat, selectedGeometry } =
    props;

  /**
   * Full stats are full width and have an onclick
   */
  const fullStats = CRT.stats.large;

  /**
   * short stats are half width and dont have an onclick
   */
  const shortStats = CRT.stats.small;

  const country = utils.getCountryAttrForSelectedGeometry(
    selectedGeometry
  );

  return (
    <div className="coralRecTourismStats">
      {Object.keys(stats).length > 0 && (
        <>
          <Grid container className="short-stat-container">
            {shortStats.map((item) => (
              <SmallStat
                key={item.name}
                size={6}
                item={item}
                stats={stats}
                country={country}
              />
            ))}
          </Grid>
          <div className="large-stat-container">
            {fullStats.map((item) => (
              <LargeStat
                key={item.name}
                item={item}
                handleStatClick={handleStatClick}
                selectedStat={selectedStat}
                stats={stats}
                country={country}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
}

export default CoralRecStats;
